import { render, staticRenderFns } from "./HomeNew2.vue?vue&type=template&id=52cb9348&scoped=true&"
import script from "./HomeNew2.vue?vue&type=script&lang=js&"
export * from "./HomeNew2.vue?vue&type=script&lang=js&"
import style0 from "./HomeNew2.vue?vue&type=style&index=0&id=52cb9348&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cb9348",
  null
  
)

export default component.exports